import React from 'react';

// Spec §15 ActionButton — primary/outline/ghost variants, shared sizing,
// loading state swaps the start icon for a spinner and the label for
// "Please wait...".
const VARIANT_CLASSES = {
  primary: 'bg-actionPrimary text-white hover:bg-actionPrimaryHover border border-transparent',
  outline: 'bg-white text-textPrimary border border-inputBorder hover:bg-panelHover',
  ghost: 'bg-transparent text-textSecondary border border-transparent hover:text-textPrimary hover:bg-black/5',
};

const DANGER_GHOST = 'bg-transparent text-signOut border border-transparent hover:bg-red-50';

const Spinner = () => (
  <svg className="animate-spin w-4 h-4" viewBox="0 0 24 24" fill="none">
    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
  </svg>
);

const ActionButton = ({
  variant = 'primary',
  danger = false,
  loading = false,
  startIcon: StartIcon,
  endIcon: EndIcon,
  children,
  className = '',
  disabled = false,
  ...rest
}) => {
  const variantClass = variant === 'ghost' && danger ? DANGER_GHOST : VARIANT_CLASSES[variant] || VARIANT_CLASSES.primary;

  return (
    <button
      type="button"
      disabled={disabled || loading}
      className={[
        'inline-flex items-center justify-center gap-2 rounded-radiusSm font-semibold transition-colors duration-150 px-4 py-2 disabled:opacity-50 disabled:cursor-not-allowed',
        variantClass,
        className,
      ].join(' ')}
      style={{ fontSize: '0.875rem' }}
      {...rest}
    >
      {loading ? <Spinner /> : StartIcon && <StartIcon className="w-4 h-4" style={{ strokeWidth: 1.75 }} />}
      {loading ? 'Please wait...' : children}
      {!loading && EndIcon && <EndIcon className="w-4 h-4" style={{ strokeWidth: 1.75 }} />}
    </button>
  );
};

export default ActionButton;
